import React from "react";
import { Link } from "@tanstack/react-router";

interface BuilderLinkProps {
  href: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
  children?: React.ReactNode;
}

export const BuilderLink = ({ href, target, children }: BuilderLinkProps) => {
  // If it's an external link, use a regular anchor tag
  if (
    href.startsWith("http://") ||
    href.startsWith("https://") ||
    href.startsWith("//")
  ) {
    return (
      <a
        href={href}
        target={target}
        rel={"_blank" === target ? "noopener noreferrer" : undefined}
      >
        {children}
      </a>
    );
  }

  // For internal links, use TanStack Router's Link
  return (
    <Link to={href} target={target}>
      {children}
    </Link>
  );
};
